import apiService from './api-service';

export const vehicleService = {
	getVehicles
};

async function getVehicles() {
	const vehicles = await apiService.get('vehicle/getVehicles');
	return vehicles;
}